/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2018, Zumper
 * @description calculateBoxForListing
 */

import feetToDegreesAtLatitude from './feetToDegreesAtLatitude'

/**
 * Calculates the box for a listing. Box is used for local alerts generated from details and
 * messaging modal.
 *
 * @typedef args arguments
 * @type {object}
 *  @property {number} miles The square radius in miles from the listing.
 *  @property {number} lat
 *  @property {number} lng
 * @returns {{minLng: number, maxLng: number, minLat: number, maxLat: number}} box The min/max lat/lng for the square around the listing.
 */
const calculateBoxForListing = (/** @type {args} */ { miles, lat, lng }) => {
  const delta = feetToDegreesAtLatitude(lat, [miles * 5280])[0]

  return {
    minLng: lng - delta.lng,
    maxLng: lng + delta.lng,
    minLat: lat - delta.lat,
    maxLat: lat + delta.lat,
  }
}

export default calculateBoxForListing
